var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"w-full underline truncate",attrs:{"href":`${_vm.URL}${_vm.text.split(' ').join('+')}`,"target":"_blank"},on:{"click":function($event){$event.stopPropagation();}}},[_c('t-text',{class:_vm.textClass,attrs:{"color":"unset","size":_vm.textSize}},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }